// Where a capability comes from. A team's role sets its own (Role); the org
// admin sets the shared ones, Development and Standards, and applies each to
// the roles it is for. Every capability shows its source wherever it appears,
// in the colour of the program type that builds it.

import { PROGRAM_TYPE_COLORS } from '../Program/components/learning-lifecycle/constants';

export type SharedKind = 'development' | 'standards';
export type CapabilitySource = 'role' | SharedKind;

export const SHARED_KINDS: SharedKind[] = ['development', 'standards'];

export const SOURCE_LABEL: Record<CapabilitySource, string> = {
  role: 'Role',
  development: 'Development',
  standards: 'Standards'
};

export const SOURCE_COLOR: Record<CapabilitySource, string> = {
  role: PROGRAM_TYPE_COLORS['role-excellence'],
  development: PROGRAM_TYPE_COLORS.development,
  standards: PROGRAM_TYPE_COLORS.standards
};

/** The source a capability (or a row about one) carries; a role's own when it says none, as everything before shared ones did. */
export const sourceOf = (item: { source?: string | null } | null | undefined): CapabilitySource =>
  item?.source === 'development' || item?.source === 'standards' ? item.source : 'role';

export const isSharedKind = (value: unknown): value is SharedKind => value === 'development' || value === 'standards';
